import { AppleBtn, Button, GoogleBtn, Input } from "ui";
import { CustomComponentProps } from "utils/types/generalTypes";

export type SignupForm1Props = CustomComponentProps & {
    name: string;
    handleChangeName: Function;
    nameError: string | undefined;
    email: string;
    handleChangeEmail: Function;
    emailError: string | undefined;
    userName: string;
    handleChangeUserName: Function;
    userNameError: string | undefined;
    changeStep: React.Dispatch<React.SetStateAction<number>>;
    step: number;
};

const SignupForm1 = ({
    name,
    handleChangeName,
    nameError,
    email,
    handleChangeEmail,
    emailError,
    userName,
    handleChangeUserName,
    userNameError,
    changeStep,
    step
}: SignupForm1Props) => {
    return (
        <div
            id="signup-panel-1"
            className={`process-panel-wrap is-narrow ${step == 0 ? "is-active" : ""} `}
        >
            <div className="form-panel ">
                <div className="d-flex flex-col flex-j-center flex-a-center gap-10 mb-20">
                    <h3 className="fw-500">Sign up With</h3>
                    {/* <!-- google btn --> */}
                    <GoogleBtn className="fast-signup-btns" />

                    {/* <!-- apple btn --> */}
                    <AppleBtn className="fast-signup-btns" />
                    <h3 className="fw-500">Or</h3>
                </div>

                <Input
                    label="Full Name"
                    value={name}
                    handleChange={handleChangeName}
                    error={nameError}
                    placeHolder="Enter your full name"
                />

                <Input
                    label="Email"
                    type="email"
                    value={email}
                    handleChange={handleChangeEmail}
                    error={emailError}
                    placeHolder="Enter your email address"
                />

                <Input
                    label="User Name"
                    value={userName}
                    handleChange={handleChangeUserName}
                    error={userNameError}
                    placeHolder="Enter your user name"
                />
            </div>

            <div className="buttons">
                <Button text="continue" handleClick={() => changeStep(1)} />
            </div>
        </div>
    );
};

export default SignupForm1;
